import { Component, OnInit } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'
import { GoalsComponent } from 'src/app/meetings/goals/goals.component'

import { HrGoal, ListItem, RepositoryModal } from '../../../shared'
import { ScorecardComponent } from '../scorecard.component'

@Component({
    templateUrl: './hr-goal.component.html',
    standalone: true,
    imports: [FormsModule, WjInputModule, FaIconComponent],
})
export class HrGoalComponent extends RepositoryModal<HrGoal> implements OnInit {
    faQuestionCircle = faCircleQuestion

    userMap: ListItem<number>[] = []
    directionMap: ListItem<number>[] = [
        new ListItem(0, '>= (Greater Than or Equal To)'),
        new ListItem(1, '<= (Less Than or Equal To)'),
        new ListItem(2, '>= <= (Between, Inclusive)'),
        new ListItem(3, '= (Equal To)'),
    ]
    boolMap: ListItem<boolean>[] = [new ListItem(true, 'Yes'), new ListItem(false, 'No')]
    calcMap: ListItem<boolean>[] = [new ListItem(false, 'Year-to-date'), new ListItem(true, 'Rolling 12 months')]

    ngOnInit() {
        // this.services.data
        //     .get<VpUser[]>('api/VpUser/GetVistaUsers', new HttpParams().set('activeOnly', true))
        //     .subscribe({ next: result => (this.userMap = result.map(x => new ListItem(x.id, x.name))) })

        const parentComponent = this.editOptions.initializeParams as ScorecardComponent | GoalsComponent
        this.userMap = parentComponent.allUsers.map(x => new ListItem(x.id, x.name))

        if (this.isAdding) {
            this.target.format = 'N'
            this.target.isCalculated = true
            this.target.canEditHistorical = false
            this.target.isArchived = false
            this.target.showAverage = true
            this.target.showSum = true
            this.target.useRolling12Months = false
            if (parentComponent instanceof GoalsComponent) this.target.meetingId = parentComponent.meetingId()
        }
    }

    protected onInitialized() {
        console.log(this.editOptions.initializeParams)
    }

    onBeforeSave() {
        if (!this.target.name) {
            this.services.notification.warning('Metric name is required')
            return false
        }

        console.log(this.target)
        if (this.target.goalDirection === undefined) {
            this.target.goalDirection = this.directionMap[0].value
        }
        if (this.target.userId === undefined) {
            this.target.userId = this.userMap[0].value
        }
        return true
    }
}
